// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"dd6792785f16fb31","265":"488f0dafc1fd1be9"}[chunkId] + ".css";
};